<template>
  <ubi-page-container class="SyntheseContacts" wide-main-content>
    <no-contact-manager v-if="!possedeContactManager || !possedeCallTracking" />

    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">

      <div v-if="this.possedeContactManager || possedeCallTracking == true">
        <el-row>
          <el-col :span="24">
            <BoxInfos v-if="showBoxInfos" @closeBoxInfos="closeBoxInfos" :has-icon-info="false" :has-icon-close="true">
              <span style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('contact.messageLeadsQualification')}}</span>
              <router-link :to="{name: 'ProduitQualiforma'}" style="font-size: 18px;">ici</router-link> !
            </BoxInfos>
          </el-col>
          <el-col :span="24">
            <ApiSearchForm
              :key="$route.fullPath"
              route="contact/synthese-contacts"
              :business-domain="sitimmoUser.univers.toLowerCase()"
              :user-context="userContext"
              :hide-search-field="true"
              :hide-more-button="true"
              @search="handleSearchFromApi"
              @config-loaded="handleConfigLoaded"
              @ready="handleSearchFormReady"
            />
          </el-col>
        </el-row>
        <ubi-panel :title="$t('contacts.accumulatedIndicators')">
          <el-row>
            <el-col :span="8" v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" >
              <el-button v-loading="loadingExport" @click="exporterContacts">
                {{ $t("contacts.exportEmailContacts") }}
              </el-button>
            </el-col>
            <el-col :span="8">
              <strong>{{nbContactsGeneresTotal + totalContactsCalltracking}}</strong>
              {{ $t("contacts.generatedContactsTotal", {count: nbContactsGeneresTotal + totalContactsCalltracking}) }}
              <el-tooltip placement="top-start" :content="$t('contacts.tooltipTotal')">
                <em class="el-icon-question"></em>
              </el-tooltip>
              <br>
              <strong>{{nbContactsGeneres}}</strong>
              {{ $t("contacts.generatedContactsActiveAds", {count: nbContactsGeneres}) }}
              <el-tooltip placement="top-start" :content="$t('contacts.tooltipActiveAds')">
                <em class="el-icon-question"></em>
              </el-tooltip>
            </el-col>
            <el-col :span="8" v-if="possedeCallTracking">
              <strong>{{nbContactsGeneresTotal}}</strong> {{ $t("contacts.contactsByEmail") }}
              <br />
              <strong>{{totalContactsCalltracking}}</strong> {{ $t("contacts.contactsByPhone") }}
              <br />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <br />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-button class="inline" v-if="possedeCallTracking || totalContactsCalltracking > 0" @click="exportCalls">
                {{ $t("contacts.exportPhoneContacts") }}
              </el-button>
            </el-col>
            <el-col :span="8">
              <br />
              <strong>{{ nbAnnoncesDiffusees }}</strong> {{ nbAnnoncesDiffusees ? $t("contacts.adsSent_plural") : $t("contacts.adsSent") }}
              <br />
              <strong>{{ nbPortailsActifs }}</strong> {{ nbPortailsActifs ? $t("contacts.activePortals_plural") : $t("contacts.activePortals") }}
              <br />
            </el-col>
            <el-col :span="8"></el-col>
            <el-row v-if="isPromoteur">
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t("portals.broadcast.quotaProgram") }} :</strong>
                <br/>
                <div>{{ this.nbAnnoncesDiffuseesProgrammes}} / {{ this.nbProgrammesTotal}}</div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t("portals.broadcast.quotaLot") }} :</strong>
                <br/>
                <div>{{ this.nbAnnoncesDiffuseesLots}} / {{ this.nbLotsTotal}}</div>
              </el-col>
            </el-row>
          </el-row>
        </ubi-panel>

        <ubi-panel :title="$t('contacts.activityDistributionTitle')" v-if="this.sitimmoUser.univers == 'IMMO'">
          <el-row>
            <el-col :span="7">
              <div class="text-muted" style="text-align: center;">
                <pie-chart
                  :chart-data="graphDataTypesOffres"
                  :options="null"
                  v-if="graphDataTypesOffres != null"
                ></pie-chart>
                <div v-else style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                <br>{{ $t("contacts.activityDistributionOffers") }}
              </div>
            </el-col>
            <el-col :span="1">
              <br />
            </el-col>
            <el-col :span="7">
              <div class="text-muted" style="text-align: center;">
                <pie-chart
                  :chart-data="graphDataTypesBiens"
                  :options="null"
                  v-if="graphDataTypesBiens != null"
                ></pie-chart>
                <div v-else style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                <br>{{ $t("contacts.activityDistributionProperties") }}
              </div>
            </el-col>
            <el-col :span="1">
              <br />
            </el-col>
            <el-col :span="7">
              <div class="text-muted" style="text-align: center;">
                <pie-chart
                  :chart-data="graphDataPortals"
                  :options="null"
                  v-if="graphDataPortals != null"
                ></pie-chart>
                <div v-else style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                <br>{{ $t("contacts.activityDistributionPortals") }}
              </div>
            </el-col>
          </el-row>
        </ubi-panel>
        <ubi-panel :title="$t('contacts.activityDistributionTitleVO')" v-else>
          <el-row type="flex" justify="left">
            <el-col :span="16">
              <bar-chart-horizontal :chart-data="graphDataPortals" v-if="!aucunPortail"></bar-chart-horizontal>
              <div class="text-muted text-center" v-else>{{ $t("contacts.activityDistributionNoData") }}</div>
            </el-col>
          </el-row>
        </ubi-panel>

        <ubi-panel :title="$t('contacts.performancePortailsAnnonces')">
          <p>
            {{ $t("dashboard.cmYouReceived") }}
            <strong>{{ $t("dashboard.cmContactsWithCount", {count: nbContacts}) }}</strong>
            {{ $t("dashboard.cmLast7Days") }}
          </p>
          <template v-slot:left-column>
            <div class="block">
              <div class="block-header">
                <h4>{{ $t("dashboard.cmPortals") }}</h4>
              </div>
              <div class="block-body">
                <el-table :data="contactsStats">
                  <el-table-column :label="$t('dashboard.cmColumnTitle')">
                    <template v-slot="{ row: portal }">
                      <ubi-icon name="direction" class="text-primary pr-2"/>
                      <strong class="font-secondary">{{ portal[1].nom }}</strong>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('dashboard.cmColumnContacts')" align="right" width="80">
                    <template v-slot="{ row: portal }">{{ portal[1].nb_contacts }}</template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="block-footer">
                <router-link :to="{ name: 'contacts-portals' }">
                  <el-link @click="eventAnalytics('cm_rapport_complet_portails')">{{
                      $t("dashboard.fullReportLink")
                    }}
                  </el-link>
                </router-link>
              </div>
            </div>
          </template>
          <template v-slot:right-column>
            <div class="block">
              <div class="block-header">
                <h4>{{ $t("dashboard.cmAds") }}</h4>
              </div>
              <div class="block-body">
                <el-table :data="contactsPosts">
                  <el-table-column :label="$t('dashboard.cmColumnTitle')">
                    <template v-slot="{ row: post }">
                      <ubi-icon name="direction" class="text-primary pr-2"/>
                      {{ post.reference }} - {{ post.titre }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('dashboard.cmColumnContacts')" align="right" width="80">
                    <template v-slot="{ row: post }">{{ (post.nbContactsMailtracking && post.nbContactsMailtracking.nbContact) || 0 }}</template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="block-footer">
                <router-link :to="{ name: 'contacts-posts' }">
                  <el-link @click="eventAnalytics('cm_rapport_complet_annonces')">{{
                      $t("dashboard.fullReportLink")
                    }}
                  </el-link>
                </router-link>
              </div>
            </div>
          </template>
        </ubi-panel>

        <ubi-panel :title="$t('contacts.contactDetailsTitle')" >
          <el-row>
            <el-col :span="12">
              <div class="text-muted" style="text-align: center;">
                <bar-chart :chart-data="graphDataMonthly" ></bar-chart>{{ $t("contacts.contactDetailsLastMonths") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="text-muted" style="text-align: center;">
                <bar-chart :chart-data="graphDataDaily" ></bar-chart>{{ $t("contacts.contactDetailsLastDays") }}
              </div>
            </el-col>
          </el-row>
        </ubi-panel>
      </div>
    </div>
  </ubi-page-container>

</template>

<script>
import moment from 'moment'
import { getSwitchedToken } from '@/services/auth'
import { Collapse, CollapseItem, Divider } from 'element-ui'
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  getContactsAnnoncesEnTete,
  getMonthlyContacts,
  getDailyContacts,
  getNbCalls,
  orderNbCalls,
  exportContacts,
  getContactsPortailEnTete,
  exportCalls,
  getContactsPortailsEnTete,
  getAnnoncesContacts
} from '@/services/contacts'
import PieChart from '../../services/piechart'
import BarChart from '../../services/barchart'
import BarChartHorizontal from '../../services/barchartHorizontal.js'

import { getNbTotalLots, getNbTotalProgrammes } from '@/services/posts'
import downloadexcel from 'vue-json-excel'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import NoContactManager from '@/pages/contacts/NoContactManager.vue'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
import UbiIcon from '@/components/Icon.vue'

export default {
  name: 'SyntheseContacts',
  inject: ['browserContext'],
  components: {
    UbiIcon,
    UbiPanel,
    UbiPageContainer,
    NoContactManager,
    BoxInfos,
    PieChart,
    BarChart,
    BarChartHorizontal,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    downloadexcel,
    ApiSearchForm
  },
  data () {
    return {
      loading: false,
      nbResults: 0,
      enTete: null,
      contactsAnnoncesEnTete: null,
      contactsPortailEnTete: null,
      contactsPortailsEnTete: null,
      graphDataTypesBiens: null,
      graphDataTypesOffres: null,
      totalContactsCalltracking: 0,
      graphDataPortals: null,
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      contacts: null,
      nbPortailsActifs: 0,
      totalAnnonces: 0,
      contactsMonthly: null,
      contactsDaily: null,
      graphDataMonthly: null,
      graphDataDaily: null,
      graphData: {},
      aucunPortail: false,
      marginLeftContacts: 0,
      marginLeftPortails: 0,
      nbAnnoncesDiffuseesLots: 0,
      nbAnnoncesDiffuseesProgrammes: 0,
      nbAnnoncesDiffusees: 0,
      nbLotsTotal: 0,
      nbProgrammesTotal: 0,
      filters: [],
      annoncesStats: {},
      infosPortails: [],
      loadingExport: false,
      showBoxInfos: true,
      nbContacts: 0,
      contactsStats: [],
      contactsPosts: []
    }
  },
  beforeMount () {
    // Initialiser les filtres avec les dates du store global avant que ApiSearchForm ne se monte
    const beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    const afterContacts = this.$store.getters['donnees/getContactsDateAfter']

    if (beforeContacts !== undefined && beforeContacts !== null) {
      this.filter.beforeContacts = beforeContacts
    }
    if (afterContacts !== undefined && afterContacts !== null) {
      this.filter.afterContacts = afterContacts
    }

    console.log('📅 [SyntheseContacts beforeMount] Filtres initialisés:', {
      beforeContacts: this.filter.beforeContacts,
      afterContacts: this.filter.afterContacts
    })
    // Note: fetchData() sera appelé par handleSearchFromApi() après que ApiSearchForm émette @search
  },
  computed: {
    ...mapGetters(['isSubUser', 'getPickerOptionsShortcuts']),
    ...mapState('contacts', ['filter', 'results']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    possedeCallTracking () {
      return getFromSnake(this.sitimmoUser, 'possede_call_tracking')
    },
    cockpitLogin () {
      return this.sitimmoUser.cockpitLogin
    },
    user () {
      return this.$store.getters.getUser
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    saveFilters () {
      return this.$store.state.saveFilters
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    // === PROPRIÉTÉS POUR ApiSearchForm ===
    userContext () {
      return {
        userId: this.sitimmoUser.id,
        univers: this.sitimmoUser.univers,
        metier: this.sitimmoUser.metier,
        betaTesteur: this.sitimmoUser.betaTesteur || false
      }
    }
  },
  mounted () {
    this.userEmail = this.user.email
  },
  methods: {
    async getEnTete () {
      if (this.possedeContactManager || this.possedeCallTracking) {
        this.enTete = await getContactsPortailEnTete(this.filter, this.portalId)
      }
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('contacts', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter'
    ]),
    eventAnalytics (category) {
      this.$ga.event('contact_manager', 'clic', category, this.sitimmoUser.id)
    },
    findNbContacts (annonce) {
      for (const [key, value] of Object.entries(this.annoncesStats || {})) {
        if (key === annonce.reference) {
          annonce.nbContactsMailtracking = (value && typeof value === 'object' && 'nbContact' in value) ? value : { nbContact: value }
          return
        }
      }
      annonce.nbContactsMailtracking = annonce.nbContactsMailtracking == null ? { nbContact: 0 } : annonce.nbContactsMailtracking
    },
    closeBoxInfos (args) {
      if (args === 'close') {
        this.showBoxInfos = false
      }
    },
    resetGraph () {
      this.infosPortails = {}
    },
    async fetchData () {
      this.resetGraph()
      this.setLoading(true)
      try {
        this.commitFilters()

        const [contactsAnnoncesEnTete, contactsPortailEnTete, contactsPortailsEnTete, monthlyContacts, dailyContacts, nbCalls] = await this.fetchAllData()

        this.validateResults(contactsAnnoncesEnTete, contactsPortailsEnTete, contactsPortailEnTete, nbCalls)

        this.processData(contactsAnnoncesEnTete, contactsPortailEnTete, contactsPortailsEnTete, monthlyContacts, dailyContacts, nbCalls)

        if (this.annoncesStats && Object.keys(this.annoncesStats).length > 0) {
          try {
            const refs = this.triReferences(this.annoncesStats)
            const contactsPostsCall = await getAnnoncesContacts({
              page: 1,
              perPage: 4,
              refs,
              beforeContacts: this.filter.beforeContacts,
              afterContacts: this.filter.afterContacts
            })
            if (contactsPostsCall.type !== 'error' && contactsPostsCall.infos && contactsPostsCall.infos._embedded && contactsPostsCall.infos._embedded.annonce) {
              this.contactsPosts = contactsPostsCall.infos._embedded.annonce
              this.contactsPosts.forEach(el => this.findNbContacts(el))
            } else {
              this.contactsPosts = []
            }
          } catch (e) {
            console.error('Erreur récupération annonces contacts SyntheseContacts:', e)
            this.contactsPosts = []
          }
        } else {
          this.contactsPosts = []
        }

        if (this.isPromoteur) {
          await this.chargementPromoteur()
        }

        this.generateGraphs()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.setLoading(false)
      }
    },
    commitFilters () {
      // Ne commit au store global QUE si les dates sont définies dans this.filter
      // Sinon, on garde les valeurs existantes du store global
      if (this.filter.beforeContacts !== undefined && this.filter.beforeContacts !== null) {
        this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      }
      if (this.filter.afterContacts !== undefined && this.filter.afterContacts !== null) {
        this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      }
    },
    async fetchAllData () {
      return await Promise.all([
        getContactsAnnoncesEnTete(this.filter),
        getContactsPortailEnTete(this.filter),
        getContactsPortailsEnTete(this.filter),
        getMonthlyContacts(),
        getDailyContacts(),
        getNbCalls(this.filter, null)
      ])
    },
    validateResults (contactsAnnoncesEnTete, contactsPortailEnTete, nbCalls) {
      if (contactsAnnoncesEnTete.type === 'error' || contactsPortailEnTete.type === 'error' || nbCalls.type === 'error') {
        throw new Error(this.$t('error.found'))
      }
    },
    processData (contactsAnnoncesEnTete, contactsPortailEnTete, contactsPortailsEnTete, monthlyContacts, dailyContacts, nbCalls) {
      this.contactsAnnoncesEnTete = contactsAnnoncesEnTete
      this.contactsPortailEnTete = contactsPortailEnTete
      this.contactsPortailsEnTete = contactsPortailsEnTete
      this.contactsMonthly = { infos: monthlyContacts.data }
      this.contactsDaily = { infos: dailyContacts.data }
      this.callsPerPortal = orderNbCalls(nbCalls)
      this.updateStatistics()
    },
    updateStatistics () {
      this.totalContactsCalltracking = this.callsPerPortal.TOTAL_CONTACTS_CALLTRACKING
      this.nbContactsGeneres = this.contactsAnnoncesEnTete.infos.nbContactsGeneres
      this.nbContactsGeneresTotal = this.contactsAnnoncesEnTete.infos.nbContactsGeneresTotal
      this.nbAnnonces = this.contactsAnnoncesEnTete.infos.nbAnnonces
      this.nbProspects = this.contactsAnnoncesEnTete.infos.nbProspects
      this.nbPortailsActifs = this.contactsAnnoncesEnTete.infos.nbPortailsActifs
      this.nbAnnoncesDiffusees = this.contactsAnnoncesEnTete.infos.nbAnnoncesDiffusees
      this.nbAnnoncesDiffuseesLots = this.contactsPortailsEnTete.infos.nbAnnoncesDiffuseesLots
      this.nbAnnoncesDiffuseesProgrammes = this.contactsPortailsEnTete.infos.nbAnnoncesDiffuseesProgrammes
      this.annoncesStats = this.contactsAnnoncesEnTete.infos.infosAnnonces

      // Données pour le bloc Contact Manager (portails + nb contacts)
      this.nbContacts = this.contactsAnnoncesEnTete.infos.nbContactsGeneres || 0
      this.contactsStats = []
      const dataPortails = this.contactsPortailEnTete.infos.infosPortails || {}
      for (const i of Object.keys(dataPortails)) {
        const infos = dataPortails[i]
        if (infos && Object.values(infos).length > 0) {
          this.contactsStats.push([i, infos])
        }
      }

      for (const [key, value] of Object.entries(dataPortails)) {
        if (value.nom !== undefined) {
          this.infosPortails[value.nom] = value.nb_contacts
        }
      }
    },
    triReferences (referencesObj) {
      if (!referencesObj || typeof referencesObj !== 'object') return ''
      const referencesTuples = Object.entries(referencesObj)
      const valeurs = Object.values(referencesObj).map(v => (v && typeof v === 'object' && 'nbContact' in v ? v.nbContact : v))
      const toutesEgales = valeurs.length > 0 && valeurs.every(v => v === valeurs[0])
      const resultatArray = toutesEgales
        ? referencesTuples.slice(0, 4).map(([ref]) => ref)
        : referencesTuples
          .sort(([, a], [, b]) => ((b && typeof b === 'object' && 'nbContact' in b ? b.nbContact : b) - (a && typeof a === 'object' && 'nbContact' in a ? a.nbContact : a)))
          .slice(0, 4)
          .map(([ref]) => ref)
      return resultatArray.join(',')
    },
    generateGraphs () {
      const typeObject = {
        ...this.contactsAnnoncesEnTete.infos.tabTypesObject
      }
      const typeOffre = {
        ...this.contactsAnnoncesEnTete.infos.tabTypesOffre
      }
      const typePortail = {
        ...this.infosPortails
      }
      delete typeObject['Post éditorial']
      delete typeOffre['Visualisation de post éditorial']

      this.graphDataTypesBiens = this.createGraphData(typeObject, [
        'rgba(255,99,132,0.55)',
        'rgba(54, 162, 235, 0.55)',
        'rgba(255, 206, 86, 0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      this.graphDataTypesOffres = this.createGraphData(typeOffre, [
        'rgba(255, 206, 86, 0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      this.graphDataPortals = this.createGraphData(typePortail, [
        'rgba(54, 162, 235, 0.55)',
        'rgba(255,206,86,0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      const blueColor = 'rgba(54, 162, 235, 0.55)'
      this.graphDataDaily = this.createGraphData(this.contactsDaily.infos, Array(Object.keys(this.contactsDaily.infos).length).fill(blueColor))
      this.graphDataMonthly = this.createGraphData(this.contactsMonthly.infos, Array(Object.keys(this.contactsMonthly.infos).length).fill(blueColor))
    },
    createGraphData (data, colors) {
      const labels = Object.keys(data).map(label => label.charAt(0).toUpperCase() + label.slice(1))
      const values = Object.values(data)
      return values.length > 0
        ? {
            labels: labels,
            datasets: [
              {
                label: '# of Votes',
                data: values,
                borderWidth: 0,
                backgroundColor: colors
              }
            ]
          }
        : null
    },
    setLoading (value) {
      this.loading = value
    },
    handleError (error) {
      this.$message({ message: error.message, type: 'error' })
    },
    doFilter (type) {
      if (type === 'reset') {
        this.resetFilter()
      }
      this.fetchData()
    },
    async exporterContacts () {
      this.eventAnalytics('export_contacts_mail')
      this.loadingExport = true
      this.filter.exportType = 'contact_mailtracking'
      const res = await exportContacts(this.filter)
      this.loadingExport = false
      this.$message(res)
    },
    async exportCalls () {
      this.loading = true
      const res = await exportCalls(this.filter, null, this.$t('contacts.filenameExportContactsCalls'))
      this.$message(res)
      this.loading = false
    },
    async switchToCockpit () {
      const switchedToken = await getSwitchedToken(this.cockpitLogin)
      const switchURL = processEnvConfig.VUE_APP_COCKPIT_URL + '/login?token=' + switchedToken
      window.open(switchURL, '_blank')
    },
    async chargementPromoteur () {
      this.nbProgrammesTotal = await getNbTotalProgrammes('ag' + this.sitimmoUser.id, false)
      this.nbLotsTotal = await getNbTotalLots('ag' + this.sitimmoUser.id, false)
      if (this.nbProgrammesTotal.type === 'error' || this.nbLotsTotal.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
    },
    // === MÉTHODES POUR ApiSearchForm ===
    handleSearchFromApi (filters) {
      console.log('🔍 SyntheseContacts - Filtres reçus de ApiSearchForm:', filters)
      console.log('📊 SyntheseContacts - État actuel de this.filter:', {
        beforeContacts: this.filter.beforeContacts,
        afterContacts: this.filter.afterContacts
      })

      const mappedFilters = {}

      // Date range (beforeContacts/afterContacts)
      // IMPORTANT: Ne jamais passer undefined car addFilter() supprime les clés undefined
      // Si les dates sont présentes dans filters ET non undefined, les utiliser
      if (filters.beforeContacts !== undefined && filters.beforeContacts !== null) {
        mappedFilters.beforeContacts = filters.beforeContacts
      }
      if (filters.afterContacts !== undefined && filters.afterContacts !== null) {
        mappedFilters.afterContacts = filters.afterContacts
      }

      console.log('📝 SyntheseContacts - Filtres à ajouter:', mappedFilters)

      // Appliquer les filtres s'il y en a
      // Si mappedFilters est vide, this.filter garde ses valeurs actuelles (initialisées dans beforeMount)
      if (Object.keys(mappedFilters).length > 0) {
        this.addFilter(mappedFilters)
      }

      console.log('✅ SyntheseContacts - État final de this.filter avant fetchData:', {
        beforeContacts: this.filter.beforeContacts,
        afterContacts: this.filter.afterContacts
      })

      this.fetchData()
    },
    handleConfigLoaded (config) {
      console.log('⚙️ SyntheseContacts - Configuration chargée:', config)
    },
    handleSearchFormReady () {
      console.log('✅ SyntheseContacts - Formulaire de recherche prêt')
      // Ne pas appeler fetchData() ici, ApiSearchForm va automatiquement émettre la recherche
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.SyntheseContacts {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }
}

#lienBouton1{
  color: grey;
  text-decoration: none;
}
#lienBouton2{
  color: white;
  text-decoration: none;
}
.el-loading-spinner{
  top:10%!important;
}
</style>
